module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/theme3-ee5c3ff693a6174fa3c61852bc7dfd18.png";